import zIndex from "@mui/material/styles/zIndex";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  bookingiconbuttonopen:{
    position: "absolute !important",
   // zIndex: 999,
    right: "0px",
    top: "93px", 
    color: "black",
  },
  drawerformbox:{
    width: 425,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
    boxSizing: 'border-box',
    right: 0,
    padding : "25px",
    top: "107px",
    height: "50%",
    zIndex:99,
    },
  },
  bookingformbox:{ 
    width: "100%", 
    maxWidth: "460px", 
    minWidth: 0,
    height: '100%',
    background: "#fff", 
    borderRadius: 16, 
    padding : "24px 28px",
    margin: "0 auto",
    position:"relative",
    boxSizing: 'border-box',
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    '@media (max-width: 600px)': {
      maxWidth: '100%',
      padding: '18px 14px',
      borderRadius: 12,
      minHeight: 'auto',
    },
  },
  formboxcloseicon:{
    position: "absolute !important",
    right: "422px",
    top: "92px",
    zIndex:999,
    background:"#000000b5 !important",
    color: "#fff !important",
    cursor: "pointer",
    height: "36px",
    width: "35px",
    transition: "color 0.3s ease",
    "&:hover":{
      color: "#FF0000 !important",
    }
  },
  autocomplete_control:{
    padding : "4px 0px",
  },
  booking_header:{
    color: theme.palette.common.black,
    paddingTop: 4,
    paddingBottom: 8,
    textAlign: "center",
    "& .MuiTypography-h5":{
      fontWeight: 900,
      fontSize: "1.6rem",
      letterSpacing: "-0.5px",
    },
  },
  booking_tabs:{
    display: "flex",
    justifyContent: "center",
    background: "#fff",
    border: "1px solid #eaeaea",
    borderRadius: 999,
    padding: 4,
    width: "100%",
    margin: "0 auto 16px auto",
  },
  tabButton: {
    flex: 1,
    textTransform: "none",
    borderRadius: 999,
    fontWeight: 600,
    padding: "8px 16px",
    fontSize: "14px",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
  },
  activeTab: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    '&:hover': {
      backgroundColor: "#222",
    }
  },
  inactiveTab: {
    backgroundColor: "transparent",
    color: "#888",
    '&:hover': {
      backgroundColor: "#f5f5f5",
      color: "#333",
    }
  },
  autocomplete_inputs:{
    flex: 1,
    borderRadius: 8,
    width:"100%",
    margin: "0 !important",
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      height: '38px',
      background: "#f9fafb",
      '& fieldset': {
        borderColor: '#eaeaea',
      },
      transition: "all 0.2s ease",
      '&:hover fieldset': {
        borderColor: '#ccc',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#111',
        borderWidth: '1px',
      },
    },
  },
   textarea_inputs:{
    flex: 1,
    borderRadius: 8,
    width:"100%",
    margin: "0 !important",
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      background: "#f9fafb",
      '& fieldset': {
        borderColor: '#eaeaea',
      },
      transition: "all 0.2s ease",
      '&:hover fieldset': {
        borderColor: '#ccc',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#111',
        borderWidth: '1px',
      },
    },
  },
  customInput:{
    flex: 1,
    borderRadius: 8,
    width:"100%",
    margin: "0 !important",
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      minHeight: '38px',
      background: "#f9fafb",
      '& fieldset': {
        borderColor: '#eaeaea',
      },
      transition: "all 0.2s ease",
      '&:hover fieldset': {
        borderColor: '#ccc',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#111',
        borderWidth: '1px',
      },
    },
  },
  containerformik:{
    margin:"0px 0 8px 0 !important",
    width: "100%",
  },
  formikgrids:{
    padding:"0px",
  },
  switchWrapper:{
    margin:"8px 0 0 0",
    textAlign:"center",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  primaryButton:{
    width: "100%",
    backgroundColor: "#1a1a1a",
    color: theme.palette.common.white,
    padding: "16px 24px",
    borderRadius: 30,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "15px",
    boxShadow: "none",
    '&:hover': {
      backgroundColor: "#000",
    },
  },
  secondaryButton:{
    width: "100%",
    backgroundColor: "#000",
    color: theme.palette.common.white,
    padding: "16px 24px",
    borderRadius: 30,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "15px",
    boxShadow: "none",
    '&:hover': {
      backgroundColor: "#333",
    },
  },
  scheduleInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      height: '38px',
      background: '#fff',
      '& fieldset': {
        borderColor: '#dcdcdc',
      },
      transition: "all 0.2s ease",
      '&:hover fieldset': {
        borderColor: '#999',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#111',
        borderWidth: '1px',
      },
    },
  },
}));

export default useStyles;
